import React from 'react';
import { Variants, motion } from 'framer-motion';
import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { AccountUserType } from 'shared/types';
import Icons from '../../../shared/components/Icon';
import { getDashboardAuth, useEditCurrentAccountUser } from './hooks';
import { REPORTS_URL } from '../../../utils/config';

const animationVariants: Variants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.3 } },
};

const Dashboard = ({
  currentAccountUser,
}: {
  currentAccountUser: AccountUserType;
}) => {
  const { data } = getDashboardAuth({
    dashboard: currentAccountUser.meta?.default_dashboard || undefined,
    enabled: !!currentAccountUser.meta?.default_dashboard,
  });

  const { mutate: editCurrentAccountUser } = useEditCurrentAccountUser({
    userId: currentAccountUser?.user_id || '',
  });

  const setDashboardDismissed = () => {
    editCurrentAccountUser({
      ...currentAccountUser,
      meta: { ...currentAccountUser?.meta, dashboard_dismissed: true },
    });
  };

  return (
    <Container>
      {currentAccountUser?.meta?.dashboard_dismissed ? (
        data ? (
          <iframe
            src={`${REPORTS_URL}/?appName=FreshSurvey&auth=${data}`}
            className="dashboard-iframe"
            title="dashboard"
          />
        ) : null
      ) : (
        <SampleDashboardContainer>
          <div className="alert">
            <div className="alert-content">
              <Trans
                i18nKey="dashboard.sample_dashboard_text"
                components={{
                  1: <a onClick={setDashboardDismissed} />,
                }}
              ></Trans>
            </div>
            <div className="alert-action">
              <a onClick={setDashboardDismissed}>
                <Icons glyph="close" viewBox="-9 -8 20 20" />
              </a>
            </div>
          </div>
          <div className="sample-dashboard">
            <motion.img
              src="/V5_Dashboard.png"
              alt="Sample Dashboard"
              variants={animationVariants}
              initial={'initial'}
              animate={'animate'}
            />
          </div>
        </SampleDashboardContainer>
      )}
    </Container>
  );
};

export default Dashboard;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  .dashboard-iframe {
    width: 100%;
    border: none;
    height: 100%;
  }
`;

const SampleDashboardContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .alert {
    position: absolute;
    width: 90%;
    max-width: 480px;
    font-size: 14px;
    background: #fef1e1;
    margin: 10px 0px;
    border: 1px solid #fddbb5;
    padding: 6px 20px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .alert-action {
      max-height: 24px;
    }

    a {
      font-size: 14px;
      color: var(--color-azure-800);
    }
  }

  .sample-dashboard {
    margin-top: 38px;
    padding: 22px;
  }
`;
